import { connect } from 'formik'
import { noop } from 'lodash'
import { useEffect } from 'react'
import { usePrevious } from 'react-use'

interface FormikEffectProps {
  formik: any
  onCancel?: (showValidation?: boolean) => void
  onChange: (args: any) => void
}
const FormikEffect = ({ onChange = noop, formik }: FormikEffectProps) => {
  const { values, dirty } = formik
  const prevValues = usePrevious(values)

  useEffect(() => {
    // Don't run effect on form init
    if (prevValues && dirty) {
      onChange({ prevValues, nextValues: values, formik })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])

  return null
}

export default connect(FormikEffect)
